import { useSpadeSdk } from '@ps/web-core-store';
import React, { useEffect } from 'react';

const SpadeCashGames: React.FC = () => {
  const spadeSdk = useSpadeSdk();

  useEffect(() => {
    spadeSdk?.load({
      view: 'cash-games',
      element: '#spade-cash-games'
    });
  }, [spadeSdk]);

  return <div id="spade-cash-games" style={{ minHeight: 600, display: 'flex' }} />;
};

export default SpadeCashGames;
